import React, { useState, useEffect } from 'react';
import * as R from 'ramda';
import { useHistory } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';

import IndexAppBar from './index/components/IndexAppBar';
import styles from './Wrapper.module.scss';
import ResponsiveDrawer from './index/components/Drawer';
import { either } from './lib/utils/utils';
import { postJSONPS } from './lib/utils/fetch';
import { composePS } from '@cd/pipe';
import Fallback from './dynamic/components/Fallback';
import { DynamicImport, DynamicDefaultCmp } from './DynamicImport';
import { QueryClient, QueryClientProvider } from '@cd/react-query';
import { configureShopSteward } from '@cd/shopsteward/client';
import { getImage as getMemberImage } from './dynamic/components/memImage/memImage';

// Wire the Shop Steward Report package's fetch/either/image-loader adapters to
// elocal's real implementations before any of its components render.
configureShopSteward({ postJSONPS, either, getMemberImage });

const queryClient = new QueryClient({
	defaultOptions: {
		queries: {
			refetchOnWindowFocus: false
		}
	}
});

/** getNav ::  Promise(Either) */
const getNav = () =>
	composePS(
		/* R.reduce((acc, [, val]) => R.append(val, acc), []),
		R.toPairs,
		R.merge({ dupa: 'jas' }), */
		postJSONPS
	)('POST', `/nav/list`, {
		body: JSON.stringify({})
	});

const Wrapper = () => {
	const history = useHistory();
	const [mobileOpen, setMobileOpen] = useState(false);
	const [searchValue, setSearchValue] = useState('');
	const [navList, setNavList] = useState([]);

	useEffect(() => {
		getNav().then(
			either(console.log, nl => {
				setNavList(nl);
			})
		);
	}, []);

	const onChangeURL = href => {
		setMobileOpen(false);
		history.push(href);
	};
	const onSearchValue = e => {
		setSearchValue(
			R.replace(/[\\/[\](){}^$!*.?;:<>]*/gi, '', e.target.value)
		);
	};
	const onOpenNavDrawer = () => {
		setMobileOpen(true);
	};

	return (
		<QueryClientProvider client={queryClient}>
			<div className={styles.wrapper}>
				<ResponsiveDrawer
					navList={navList}
					onChangeURL={onChangeURL}
					mobileOpen={mobileOpen}
				/>
				<div className={styles.appArea}>
					<IndexAppBar
						navList={navList}
						onOpenNavDrawer={onOpenNavDrawer}
						searchValue={searchValue}
						onSearchValue={onSearchValue}
					/>
					<Switch>
						{navList.map(
							({ src, href }) =>
								src ? (
									<Route
										key={href}
										path={href}
										render={props => (
											<DynamicImport
												load={() =>
													import(
														`dynamicForms/${src}`
													)
												}
												navList={navList}
												searchValue={searchValue}
												{...props}>
												{DynamicDefaultCmp}
											</DynamicImport>
										)}
									/>
								) : (
									<Fallback key={href} />
								),

							navList
						)}
					</Switch>
				</div>
			</div>
		</QueryClientProvider>
	);
};

export default Wrapper;
